import { render, staticRenderFns } from "./Breb.vue?vue&type=template&id=08276007&scoped=true"
import script from "./Breb.vue?vue&type=script&lang=ts"
export * from "./Breb.vue?vue&type=script&lang=ts"
import style0 from "./Breb.vue?vue&type=style&index=0&id=08276007&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08276007",
  null
  
)

export default component.exports